import levels from '@/data/level'
import { mapperToOption } from '@/views/components/selects/mappers/mapperToOption'
import polarityOptions from '@/data/polarity'
import i18n from '@/i18n'

const translateYtdTitle = ytd => {
    ytd.title = i18n.t(`yearToDate.${ytd.title}`)
    return ytd
}

export default api => {
    const {
        title,
        target,
        unit_of_measurement,
        weight,
        period,
        user,
        initial_value,
        year_to_date,
        level,
        section,
        description,
        polarity,
        ranges,
    } = api
    return {
        title: title,
        target: target,
        unitOfMeasurement: mapperToOption(unit_of_measurement),
        weight: weight,
        activePeriod: mapperToOption(period, undefined, 'name'),
        owner: mapperToOption(user, undefined, 'name'),
        initialValue: initial_value,
        yearToDate: mapperToOption(translateYtdTitle(year_to_date)),
        level: { ...levels.find(l => l.value == level) },
        section: section ? mapperToOption(section) : null,
        description: description,
        polarity: polarityOptions.find(option => option.value == polarity),
        rangesOfPerformance: ranges,
    }
}
